import { AlertProps, alertClasses } from '@mui/material/Alert';
import { alpha, Theme } from '@mui/material/styles';

import { deepNavy } from '../../palette-v2';

// ----------------------------------------------------------------------

const COLORS = ['info', 'success', 'warning', 'error'] as const;

// ----------------------------------------------------------------------

export function alert(theme: Theme) {
  const lightMode = theme.palette.mode === 'light';

  const rootStyles = (ownerState: AlertProps) => {
    const { variant, severity } = ownerState;

    const standardVariant = variant === 'standard';
    const filledVariant = variant === 'filled';
    const outlinedVariant = variant === 'outlined';

    return [
      {
        // STILI COMUNI
        borderRadius: 12,
        [`& .${alertClasses.icon}`]: {
          opacity: 1,
        },
      },
      // VARIANTI PER COLORE
      ...COLORS.map((color) => ({
        ...(severity === color && {
          // 1. STANDARD (Come da screenshot Figma)
          ...(standardVariant && {
            color: deepNavy[900],
            backgroundColor: theme.palette[color][lightMode ? 'lighter' : 'darker'],
            [`& .${alertClasses.icon}`]: {
              color: theme.palette[color].main,
            },
            [`& .${alertClasses.action} .MuiIconButton-root`]: {
              color: theme.palette[color].main,
            },
          }),
          // 2. FILLED
          ...(filledVariant && {
            color: theme.palette[color].contrastText,
            backgroundColor: theme.palette[color].main,
          }),
          // 3. OUTLINED
          ...(outlinedVariant && {
            backgroundColor: alpha(theme.palette[color].main, 0.08),
            color: theme.palette[color][lightMode ? 'dark' : 'light'],
            border: `solid 1px ${alpha(theme.palette[color].main, 0.24)}`,
            [`& .${alertClasses.icon}`]: {
              color: theme.palette[color].main,
            },
          }),
        }),
      })),
    ];
  };

  return {
    MuiAlert: {
      defaultProps: {
        variant: 'standard',
      },
      styleOverrides: {
        root: ({ ownerState }: { ownerState: AlertProps }) => rootStyles(ownerState),
        icon: {
          padding: '8px 0',
          fontSize: 24, // Icone leggermente più grandi come nel design
        },
        message: {
          padding: '8px 0',
        },
        action: {
          paddingTop: 4,
          marginRight: -8,
        },
      },
    },
    MuiAlertTitle: {
      styleOverrides: {
        root: {
          marginBottom: theme.spacing(0.5),
          fontWeight: theme.typography.fontWeightBold,
          fontSize: theme.typography.pxToRem(14),
        },
      },
    },
  };
}
